import styled from 'styled-components'
import measures from 'globals/measures'
import { Link } from 'react-router-dom'

export const TitleWrapper = styled.div`
  padding-top: 6px;
`

export const TitleLine = styled.div`
  height: 30px;
  line-height: 26px;
  font-size: 26px;
  font-family: 'Publico Roman';
  font-weight: bold;
  letter-spacing: 0.02em;
  
  @media(max-width: ${measures.mobileThreshold}px) {
    line-height: 24px;
    font-size: 18px;
  }
`

export const BackLink = styled(Link)`
  margin-right: 16px;
`
